export default "__VITE_ASSET__Da8IiRl0__"